export const wait = (durationMs: number): Promise<void> =>
    new Promise<void>((resolve: () => void): void => {
        setTimeout(resolve, durationMs);
    });
